import {setupVideoJS} from "./video-js";
import {setupErrorScreen} from "./error-screen/error";

export const defaults = {
    url: "https://play2.dotstream.nl/", // With ending slash
    autoplay: false,
    muted: false,
    errorImage: "https://mgstream.nl/studio.jpg",
    showErrorMessage: false
}

export function setupPlayer(element, settings) {
    const combined = applyDefaults(settings)

    element.innerHTML = ''

    const container = document.createElement("div")
    container.className = `mg-video-container ${combined.fullpage && 'mg-fullpage' || ''}`

    element.appendChild(container)

    setupVideoJS(container, combined)
}

// Making it globally available
window.setupPlayer = setupPlayer

function applyDefaults(settings) {
    return {
        ...settings,
        url: !settings.url ? defaults.url : settings.url,
        autoplay: typeof settings.autoplay !== "boolean" ? defaults.autoplay : settings.autoplay,
        muted: typeof settings.muted !== "boolean" ? defaults.muted : settings.muted,
        errorImage: !settings.errorImage ? defaults.errorImage : settings.errorImage,
        showErrorMessage: typeof settings.showErrorMessage !== "boolean" ? defaults.showErrorMessage : settings.showErrorMessage,
        inactivityTimeout: 0
    }
}
